import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { useTranslation } from '@pascal/pascal-core';
import { roundTimeStore } from '../../store/roundTimeStore';
import { BetShopLastResults } from '../betShopLastResults';
import { FlipCountdown } from './flipCountDown';
import LogoImg from '../../assets/images/baccarat-logo.png';

export const BetShopHeaderSection = observer(() => {
  const { betShopTime } = roundTimeStore;
  const { roundId } = roundInfoStore;
  const t = useTranslation();
  const timestamp = performance.now() + betShopTime * 1000;
  return (
    <>
      <div className='view-window-header'>
        <div className='header-container'>
          <div className='logo-block'>
            <img src={LogoImg} alt='logo' />
          </div>
          <div className='header-container-right'>
            <p className='header-race-id'>
              <span className='header-race-id-label'>{t('ROUND')}</span>
              <span className='header-race-id-value'>#{roundId}</span>
            </p>
            <FlipCountdown endTimestamp={timestamp} />
          </div>
        </div>
      </div>
      {/* Last results start  */}
      <BetShopLastResults />
      {/* Last results end  */}
    </>
  );
});
